import styled, { css } from 'styled-components';

export const StoreDetailMapSize = {
    small: '350px',
    bigger: '500px',
    big: '600px',
};

export const StoreDetailStyled = styled.div`
    margin-bottom: 40px;
`;

export const StoreDetailContentStyled = styled.div`
    ${({ theme }) => css`
        position: relative;

        font-size: 16px;

        @media ${theme.mediaQueries.queryLg} {
            min-height: ${StoreDetailMapSize.small};
            padding-right: calc(${StoreDetailMapSize.small} + 30px);
        }

        @media ${theme.mediaQueries.queryVl} {
            min-height: ${StoreDetailMapSize.bigger};
            padding-right: calc(${StoreDetailMapSize.bigger} + 30px);
        }

        @media ${theme.mediaQueries.queryXl} {
            min-height: ${StoreDetailMapSize.big};
            padding-right: calc(${StoreDetailMapSize.big} + 70px);
        }

        h6 {
            font-weight: 500;
        }
    `}
`;

export const MapStyled = styled.div`
    ${({ theme }) => css`
        width: 100%;
        height: 245px;
        margin-bottom: 16px;

        @media ${theme.mediaQueries.queryLg} {
            position: absolute;
            right: 0;
            top: 0;
            width: ${StoreDetailMapSize.small};
            height: ${StoreDetailMapSize.small};
            margin-bottom: 0;
        }

        @media ${theme.mediaQueries.queryVl} {
            width: ${StoreDetailMapSize.bigger};
            height: ${StoreDetailMapSize.bigger};
        }

        @media ${theme.mediaQueries.queryXl} {
            width: ${StoreDetailMapSize.big};
            height: ${StoreDetailMapSize.big};
        }
    `}
`;

export const DescriptionStyled = styled.div`
    ${({ theme }) => css`
        margin-bottom: 36px;

        @media ${theme.mediaQueries.queryLg} {
            margin-bottom: 24px;
        }

        & section {
            font-size: 15px;

            @media ${theme.mediaQueries.queryLg} {
                font-size: ${theme.fontSize.default};
            }
        }
    `}
`;

export const InfoItemStyled = styled.div`
    ${({ theme }) => css`
        margin: 24px 0;
        line-height: 24px;

        font-size: 15px;

        a {
            color: ${theme.color.primary};
        }
    `}
`;

export const TelephoneStyled = styled.h6`
    ${({ theme }) => css`
        font-weight: 500;
        font-size: 16px;

        a {
            color: ${theme.color.primary};
        }
    `}
`;

export const InfoItemOpeningHoursStyled = styled.div`
    width: 100%;
    margin-bottom: 24px;
`;

export const ImagesWrapperStyled = styled.div`
    ${({ theme }) => css`
        background-color: #f6f6f7;
        margin: 20px -20px 60px;
        padding: 20px;
        width: calc(100% + 40px); /* Legacy fix for Safari with negative margins */

        @media ${theme.mediaQueries.queryXl} {
            margin-left: 0;
            margin-right: 0;
            width: 100%;
        }
    `}
`;

export const ImageStyled = styled.img`
    margin: 20px;
    max-height: 200px;
`;

export const StoreBenefitsWrapperStyled = styled.div`
    margin: 40px 0;
`;
